// extracted by mini-css-extract-plugin
export var sliderRange = "_nf-2";
export var sliderRoot = "_nf-0";
export var sliderThumb = "_nf-3";
export var sliderTrack = "_nf-1";